/**
 * Stops the long-press / right-click context menu (and image drag) across the app, so a missed tap mid-game
 * never opens a share sheet or "Save image" menu. Fields and anything marked `.selectable` keep theirs.
 */
const NATIVE = 'input, textarea, select, [contenteditable]:not([contenteditable="false"]), .selectable';

export function allowsNativeMenu(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(NATIVE) !== null;
}

export function installNoCallout(doc: Document = document): () => void {
  const onMenu = (e: Event) => {
    if (!allowsNativeMenu(e.target)) e.preventDefault();
  };
  const onDrag = (e: Event) => {
    if (e.target instanceof HTMLImageElement) e.preventDefault();
  };
  doc.addEventListener('contextmenu', onMenu);
  doc.addEventListener('dragstart', onDrag);
  return () => {
    doc.removeEventListener('contextmenu', onMenu);
    doc.removeEventListener('dragstart', onDrag);
  };
}
